export default __webpack_public_path__ + "static/media/lindab_1225x150px.a2d2cb03.jpg";